import { render, staticRenderFns } from "./TheConfigParams.vue?vue&type=template&id=5d1e4e58&scoped=true"
import script from "./TheConfigParams.vue?vue&type=script&lang=js"
export * from "./TheConfigParams.vue?vue&type=script&lang=js"
import style0 from "./TheConfigParams.vue?vue&type=style&index=0&id=5d1e4e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1e4e58",
  null
  
)

export default component.exports